import React from "react";
import { PageHeader, Button, Icon, Col, Row } from "antd";

export default function Header(props) {
  return (
    <PageHeader
      title={
        <div>
          <Icon type="container" />
          &nbsp;&nbsp;<span>{props.title}</span>
        </div>
      }
      extra={[
        <div key="1">
          <Button
              icon="plus"
              type="primary"
              loading={props.loadingNew}
              onClick={props.onNew}
            >
              Nuevo
            </Button>

            <Button
            className="ml-10"
              icon="upload"
              type="primary"
              loading={props.loadingNew}
              onClick={props.onNewCargaMasiva}
            >
              Carga Masiva
            </Button>

            <Button icon="search" type="primary" ghost onClick={props.onSearch} className="ml-10">
              Buscar
            </Button>

            <Button icon="shake" type="primary" ghost onClick={props.onClearFilters} className="ml-10">
              Limpiar
            </Button>
        </div>,
      ]}
    ></PageHeader>
  );
}
